<template>
  <div v-if="products.length" :class="$style.products_recommend_area">
    <PagePartsProductListItemCarousel
      :products="products"
      :is-show-event="true"
      @click="onProductClick"
      @show="onProductShow"
    />
  </div>
</template>

<script setup lang="ts">
import type { PagePartsProductType } from "~/types/product"

type Props = {
  products: PagePartsProductType[]
  isAiRecommend?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  products: () => [],
  isAiRecommend: false,
})

const { trackRecommendProductClick, trackRecommendProductView } = useGtagEvent()

const onProductClick = (product: PagePartsProductType) => {
  if (props.isAiRecommend && product.recommend_id) {
    trackRecommendProductClick(product.document_id, product.recommend_id, "product_detail")
  }
}

const onProductShow = (product: PagePartsProductType) => {
  if (props.isAiRecommend && product.recommend_id) {
    trackRecommendProductView(product.document_id, product.recommend_id, "product_detail")
  }
}
</script>

<style scoped module lang="scss">
.products_recommend_area {
  @include container-lg;
}
</style>
